export default "__VITE_ASSET__Cqpj_JMJ__"